/* EVRYDAY Analytics v2 — fires GA4 + dataLayer (for GTM) e-commerce events sitewide.
   Meta events are managed only by Shopify's Facebook & Instagram sales channel. */
(function(){
  if(typeof window === 'undefined') return;
  var W = window;
  var ctx = (W.EVD_EVENTS_CTX) || {};
  var CURRENCY = ctx.currency || 'INR';
  W.dataLayer = W.dataLayer || [];
  var hasGA = function(){ return typeof W.gtag === 'function'; };

  function logEvent(name, payload){ if(W.console && console.log) console.log('[EVD events]', name, payload || {}); }

  function gaTrack(eventName, payload){
    if(!hasGA()) return;
    try { W.gtag('event', eventName, payload || {}); } catch(e){ logEvent('ga-err', e.message); }
  }
  // Push GA4-enhanced-ecommerce style events to dataLayer so GTM tags can pick them up
  function dlPush(eventName, payload){
    try {
      // Clear stale ecommerce object first (GA4 best practice)
      W.dataLayer.push({ ecommerce: null });
      var p = { event: eventName };
      if (payload && payload.ecommerce) {
        p.ecommerce = payload.ecommerce;
      } else if (payload) {
        // Promote items/currency/value into an ecommerce wrapper so GTM tags work out-of-the-box
        p.ecommerce = payload;
      }
      W.dataLayer.push(p);
    } catch(e){ logEvent('dl-err', e.message); }
  }

  // ============ INITIAL EVENTS BASED ON PAGE TYPE ============
  function fireInitial(){
    var t = ctx.template;
    if(!t) return;

    if(t === 'product' && ctx.product){
      var p = ctx.product;
      var item = { item_id:p.sku || String(p.id), item_name:p.title, item_brand:p.vendor || '', item_category:p.type || '', price:p.price, quantity:1 };
      gaTrack('view_item', { currency:CURRENCY, value:p.price, items:[item] });
      dlPush('view_item', { currency:CURRENCY, value:p.price, items:[item] });
      logEvent('view_item', p);
    }
    else if(t === 'collection' && ctx.collection){
      var c = ctx.collection;
      var items = (c.products || []).slice(0,20).map(function(p, i){ return { item_id:p.sku||String(p.id), item_name:p.title, item_brand:p.vendor||'', item_category:c.title, index:i, price:p.price, quantity:1 }; });
      gaTrack('view_item_list', { item_list_id: c.handle, item_list_name: c.title, items: items });
      dlPush('view_item_list', { item_list_id: c.handle, item_list_name: c.title, items: items });
      logEvent('view_item_list', c.title);
    }
    else if(t === 'cart' && ctx.cart){
      var cart = ctx.cart;
      var citems = (cart.items || []).map(function(i){ return { item_id:i.sku||String(i.product_id), item_name:i.title, item_variant:i.variant_title||'', price:i.price, quantity:i.quantity }; });
      gaTrack('view_cart', { currency: CURRENCY, value: cart.total, items: citems });
      dlPush('view_cart', { currency: CURRENCY, value: cart.total, items: citems });
      logEvent('view_cart', cart);
    }
    else if(t === 'search'){
      var q = new URLSearchParams(location.search).get('q') || '';
      if(q){
        gaTrack('search', { search_term: q });
        dlPush('search', { search_term: q });
        logEvent('search', q);
      }
    }
  }

  // ============ ADD TO CART ============
  function trackAddToCart(item){
    if(!item) return;
    var price = parseFloat(item.price) / 100 || 0; // Shopify gives cents
    var line = { item_id:item.sku||String(item.product_id), item_name:item.title || item.product_title, item_variant:item.variant_title||'', price:price, quantity:item.quantity||1 };
    gaTrack('add_to_cart', { currency:CURRENCY, value:price, items:[line] });
    dlPush('add_to_cart', { currency:CURRENCY, value:price, items:[line] });
    logEvent('add_to_cart', item);
  }

  function bindCartListeners(){
    ['cart:update','cart:added','cart:refresh'].forEach(function(evName){
      document.addEventListener(evName, function(e){
        var item = (e.detail && (e.detail.item || e.detail.line_item)) || null;
        if(item) trackAddToCart(item);
      });
    });

    var origFetch = W.fetch;
    if(origFetch){
      W.fetch = function(input, init){
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var promise = origFetch.apply(this, arguments);
        if(url.indexOf('/cart/add') !== -1){
          promise.then(function(res){
            try {
              var clone = res.clone();
              clone.json().then(function(data){
                if(data && (data.items || data.id)){
                  var items = data.items || [data];
                  items.forEach(trackAddToCart);
                }
              }).catch(function(){});
            } catch(e){}
          }).catch(function(){});
        }
        return promise;
      };
    }

    var origOpen = W.XMLHttpRequest.prototype.open;
    W.XMLHttpRequest.prototype.open = function(method, url){
      this._evdUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = W.XMLHttpRequest.prototype.send;
    W.XMLHttpRequest.prototype.send = function(){
      var self = this;
      if(self._evdUrl && self._evdUrl.indexOf && self._evdUrl.indexOf('/cart/add') !== -1){
        self.addEventListener('load', function(){
          try {
            var data = JSON.parse(self.responseText);
            if(data && (data.items || data.id)){
              var items = data.items || [data];
              items.forEach(trackAddToCart);
            }
          } catch(e){}
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  // ============ CHECKOUT ============
  function bindCheckoutListeners(){
    document.addEventListener('click', function(e){
      var t = e.target;
      var btn = t && t.closest && t.closest('button[name="checkout"], a[href*="/checkout"], button[name="add"][data-checkout], [data-evd-checkout]');
      if(btn) fireBeginCheckout();
    });
  }
  function fireBeginCheckout(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var value = cart.total_price / 100 || 0;
      var ids = cart.items.map(function(i){ return i.product_id; });
      var lines = cart.items.map(function(i){ return { item_id:i.sku||String(i.product_id), item_name:i.product_title, item_variant:i.variant_title||'', price:i.price/100, quantity:i.quantity }; });
      gaTrack('begin_checkout', { currency: CURRENCY, value: value, items: lines });
      dlPush('begin_checkout', { currency: CURRENCY, value: value, items: lines });
      logEvent('begin_checkout', cart);
    }).catch(function(){
      gaTrack('begin_checkout', { currency: CURRENCY });
      dlPush('begin_checkout', { currency: CURRENCY });
    });
  }

  // ============ NEWSLETTER / LEAD ============
  function bindLeadListeners(){
    document.addEventListener('submit', function(e){
      var form = e.target;
      if(!form || !form.matches) return;
      var isNewsletter = form.matches('form[action*="/contact"], form[action*="/customer"], form.evd-vd-gate__form, form[data-evd-newsletter], form.evdf__news-form, form#vd2-product-form');
      var emailInput = form.querySelector('input[type="email"]');
      if((isNewsletter || (emailInput && form.action && form.action.indexOf('/contact') !== -1)) && emailInput){
        var email = emailInput.value || '';
        gaTrack('generate_lead', { method: 'newsletter' });
        gaTrack('sign_up', { method: 'email' });
        dlPush('generate_lead', { method: 'newsletter' });
        dlPush('sign_up', { method: 'email' });
        logEvent('lead/sign_up', email.split('@')[0] + '@***');
      }
    });
  }

  // ============ SEARCH (live search box submissions) ============
  function bindSearchListeners(){
    document.addEventListener('submit', function(e){
      var form = e.target;
      if(form && form.matches && form.matches('form[action*="/search"]')){
        var inp = form.querySelector('input[name="q"]');
        if(inp && inp.value){
          gaTrack('search', { search_term: inp.value });
          dlPush('search', { search_term: inp.value });
          logEvent('search', inp.value);
        }
      }
    });
  }

  // ============ INIT ============
  function init(){
    fireInitial();
    bindCartListeners();
    bindCheckoutListeners();
    bindLeadListeners();
    bindSearchListeners();
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
